module.exports = __webpack_public_path__ + "img/Arrow_Right.dac6e5b0.svg";